export default __webpack_public_path__ + "static/media/getitongoogleplay.22af1d72.svg";